import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import TextCropper from '@omilia/text-cropper';

import Spinner from 'components/Spinner';

import FileUploadingProgress from './components/FileUploadingProgress';
import './style.scss';

/* eslint-disable jsx-a11y/click-events-have-key-events */
const FilePreview = ({
  file: { name, size, percentage, isLoading, hasError },
  onDelete,
}) => (
  <div
    data-test="file-preview"
    styleName={classnames('file-preview', {
      'has-error': hasError,
    })}
  >
    <div styleName="file-preview__meta">
      <TextCropper styleName="file-preview__name" text={name} />
      <span data-test="file-size">({size} bytes)</span>
    </div>

    {percentage && <FileUploadingProgress percentage={percentage} />}

    {!isLoading ? (
      <i
        className="icon-close"
        role="presentation"
        styleName="file-preview__remove"
        onClick={() => onDelete(name)}
      />
    ) : (
      <Spinner isBlue styleName="spinner" />
    )}
  </div>
);

FilePreview.propTypes = {
  onDelete: PropTypes.func.isRequired,
  file: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

export default FilePreview;
